import Vue from 'vue';
import VueRouter from 'vue-router';
import VueRouterMiddleware, { middleware } from 'vue-router-middleware';

Vue.use(VueRouter);

// Routes
import AuthRoutes from './routes/auth';
import LandlordRoutes from './routes/landlord';
import LeadRoutes from './routes/lead';
import LeaseholderRoutes from './routes/leaseholder';
import NotFound from './views/NotFound';
import PreAuthRoutes from './routes/pre-auth';
import StaffRoutes from './routes/staff';
import TenantRoutes from './routes/tenant';
import VendorRoutes from './routes/vendor';

const router = new VueRouter({
    mode: 'history',
    routes: [
        ...PreAuthRoutes,
        ...middleware('is-auth', AuthRoutes),
        ...middleware('is-owner', [
            ...LandlordRoutes,
            ...VendorRoutes,
            ...middleware('is-leaseholder-enabled', LeaseholderRoutes),
        ]),
        ...middleware('is-tenant-or-lettings-applicant', TenantRoutes),
        ...middleware('is-staff-access-enabled', StaffRoutes),
        {
            path: '*',
            component: NotFound,
            meta: {
                title: '404',
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    if(nearestWithTitle) {
        document.title = `${window.meta.themeName} ${process.env.MIX_APP_NAME} - ${nearestWithTitle.meta.title}`;
    }

    next();
});

// Router middleware
Vue.use(VueRouterMiddleware, {
    router,
    middlewares: {
        isAuth: (params, to, from, next) => {
            if (! window.meta.isAuth) {
                next({ name: 'login' });
            }
            next();
        },
        isLead: (params, to, from, next) => {
            const outcome = (window.meta.isAuth && window.meta.isLead);
            if (! outcome) {
                next({ name: 'dashboard' });
            }
            next();
        },
        isOwner: (params, to, from, next) => {
            const outcome = (window.meta.isAuth && window.meta.isOwner);
            if (! outcome) {
                next({ name: 'dashboard' });
            }
            next();
        },
        isTenantOrLettingsApplicant: (params, to, from, next) => {
            const outcome = (window.meta.isAuth && window.meta.isTenantOrLettingsApplicant);
            if (! outcome) {
                next({ name: 'dashboard' });
            }
            next();
        },
        isStaffAccessEnabled: (params, to, from, next) => {
            if (! window.meta.features.staff_access) {
                next({ name: 'login' });
            }
            next();
        },
        isLeaseholderEnabled: (params, to, from, next) => {
            if (! window.meta.features.leaseholders) {
                next({ name: 'dashboard' });
            }
            next();
        },
    }
});

export default router;
